(function(){
  function gal(root){
    (root||document).querySelectorAll('[data-tmg]').forEach(function(g){
      if(g.__tm)return;g.__tm=1;
      var main=g.querySelector('.tmg-main'),th=g.querySelector('.tmg-thumbs'),s=[].slice.call(main.querySelectorAll('.tmg-s'));
      if(s.length<2){g.querySelectorAll('.tmg-btn').forEach(function(b){b.style.display='none'});th.style.display='none';return}
      th.innerHTML='';
      s.forEach(function(x,i){var im=x.querySelector('img');if(!im)return;var t=document.createElement('img');t.src=im.currentSrc||im.src;t.alt='';t.onclick=function(){go(i)};th.appendChild(t)});
      function cur(){return Math.round(main.scrollLeft/main.clientWidth)}
      function go(i){i=(i+s.length)%s.length;main.scrollTo({left:i*main.clientWidth,behavior:'smooth'})}
      function mark(){var c=cur();[].forEach.call(th.children,function(t,i){t.classList.toggle('on',i===c)})}
      g.querySelector('.tmg-prev').onclick=function(){go(cur()-1)};
      g.querySelector('.tmg-next').onclick=function(){go(cur()+1)};
      main.addEventListener('scroll',function(){clearTimeout(g.__t);g.__t=setTimeout(mark,60)});mark();
    });
  }
  document.addEventListener('DOMContentLoaded',function(){gal()});
  document.addEventListener('shopify:section:load',function(e){gal(e.target)});
  if(document.readyState!=='loading')gal();
  document.addEventListener('click',function(e){var a=e.target.closest('a[href="#comprar"]');if(!a)return;var t=document.getElementById('comprar');if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}});
})();
